/**
 * Normalizes an annotation value for order submission.
 *
 * Ensures that annotations are always a string value, converting undefined
 * to an empty string. This provides consistent annotation handling across
 * all order entry flows (Advisor, Trader, Allocation).
 *
 * @param annotation - The annotation value from form data (may be undefined)
 * @returns A string value - either the provided annotation or an empty string
 *
 * @example
 * ```typescript
 * setAnnotation('Custom order note') // Returns: 'Custom order note'
 * setAnnotation(undefined)           // Returns: ''
 * setAnnotation('')                  // Returns: ''
 * ```
 */
export function setAnnotation(annotation?: string): string {
  return annotation || ''
}
